import { SelfServeOnboardingSettingsParser } from "@redotech/redo-model/concierge-settings/general";
import * as z from "zod/v4";

export const completeSelfServeOnboarding = {
  name: "completeSelfServeOnboarding" as const,
  input: SelfServeOnboardingSettingsParser,
  output: z.null(),
};
